<div [formGroup]="form">     
    <div class="row">
        <div class="form-group col-4" >
            <custom-select
                [filterEnabled]="true"
                [labelText]="'Tipo de documento'"
                [bordered]="true"
                name="documentType"
                id="documentType"
                (click)="_errorMessage = ''"
                formControlName="documentType"
                [(sourceList)]="_documentTypeList"
                [required]="vehiclePersonList.length > 1"
                (select)="documentNumber.value && documentType?.value?.label != 'RUT' ? onClickclearText() : documentNumber.value && documentType?.value?.label == 'RUT' ? documentChange() :null">
            </custom-select>
        </div>
        <div class="form-group col-4 input-group">
            <label [for]="'documentNumber'">N° de documento</label>
            <div class="col-10 pl-0" style="display: inline-block; padding-right: 1.5px;">
                <input
                type="text"
                #search
                customFocus
                class="form-control"
                autocorrect="off"
                autocapitalize="off"
                (click)="_errorMessage = ''"
                spellcheck="off"
                [placeholder]="'Buscar documento'"
                [id]="'documentNumber'"
                [name]="'documentNumber'"
                min="0"
                formControlName="documentNumber"
                cnm-clear-input 
                [clearVisible]='true' 
                (onClear)="onClickclearText()"
                (ngModelChange)="documentChange()"
                lang="en"
                [required]="!vehiclePerson?.value?.value ? false : true"
               />
            </div>
            <button id="search-btn" 
            type="button" 
            class="btn btn-primary col-2 align-self-center align-bottom input-group-append" 
            [tooltip]="'Consultar documento'" 
            [disabled]="!documentNumber.value || documentType?.value?.label != 'RUT'"
            (click)="onDocumentSearch(documentType?.value?.value, documentNumber.value, true); _errorMessage = ''"
            style="min-width: 38px;">
                <span *ngIf="searchStatus != 1" style="margin-left: -2px;"> <i class="fa-solid fa-magnifying-glass"></i></span>
                <span *ngIf="searchStatus === 1" style="margin-left: -2px;"><i class="fas fa-circle-notch fa-spin"></i></span>
            </button>
        </div>
        <div class="form-group col-4">
            <label for="name">Nombre</label>
            <input type="text" 
              maxlength="255"
              name="name"
              (click)="_errorMessage = ''"
              formControlName="name"
              class="form-control" 
              id="name" 
              [placeholder]="'Nombre'"
              required
              >
        </div>
        <div class="form-group col-4">
            <label for="lastName">Apellido</label>
            <input type="text" 
              maxlength="255"
              name="lastName"
              formControlName="lastName"
              (click)="_errorMessage = ''"
              class="form-control" 
              id="lastName" 
              [placeholder]="'Apellido'"
              required>
        </div>
        <div class="form-group col-4">
            <label for="country">País de origen</label>
          <custom-select
            [bordered]="true"
            (click)="_errorMessage = ''"
            name="country"
            id="country"
            formControlName="country"
            [(sourceList)]="_countries"
            required>
          </custom-select>
        </div>
        <div class="form-group col-4">
            <label for="contactAddress" class="text-truncate mb-0" style="max-width: 100%;">Dirección</label>
            <input
                type="text" 
                maxlength="255"
                name="contactAddress"
                (click)="_errorMessage = ''"
                formControlName="contactAddress"
                class="form-control" 
                id="contactAddress"
                [placeholder]="'Dirección de contacto'"
            >
        </div>
        <div class="form-group col-4">
            <label for="contactCity" class="text-truncate mb-0" style="max-width: 100%;">Ciudad</label>
            <input
                type="text" 
                maxlength="225"
                name="contactCity"
                (click)="_errorMessage = ''"
                formControlName="contactCity"
                class="form-control" 
                id="contactCity"
                [placeholder]="'Ciudad'"
            >
            </div>
        <div class="form-group col-4">
            <label for="contactPhone">Teléfono de contacto</label>
            <input
                type="contactPhone" 
                maxlength="255"
                name="contactPhone"
                (click)="_errorMessage = ''"
                formControlName="contactPhone"
                class="form-control" 
                id="contactPhone" 
                [placeholder]="'Teléfono de contacto'">
        </div>
        <div class="form-group col-4">
            <label>Correo de contacto</label>
            <input
                type="email"
                class="form-control"
                id="email"
                formControlName="email"
                [placeholder]="'Email'"
                (click)="_errorMessage = ''"
                email="true"
                name="email"/>
        </div>
        <div class="form-group col-6" >
            <custom-select
                #insurance
                [filterEnabled]="true"
                [rememberCheck]="true"
                [labelText]="'Aseguradora'"
                [bordered]="true"
                [useParentWidth]="true"
                (rememberDataEmit)="saveInsurance($event)"
                name="insuranceCompany"
                id="insuranceCompany"
                (click)="_errorMessage = ''"
                formControlName="insuranceCompany"
                [(sourceList)]="_insuranceCompanyList">
            </custom-select>
        </div>
        <div class="form-group col-6">
            <label for="insurancePolicy">Póliza de seguro</label>
            <input
            type="text" 
            maxlength="255"
            name="insurancePolicy"
            formControlName="insurancePolicy"
            class="form-control" 
            id="insurancePolicy" 
            [placeholder]="'Póliza de seguro'">
        </div>
        <div class="form-group col-6">
            <label for="dateFromInsurancePerson" class="text-truncate mb-0" style="max-width: 100%;">Fecha de vigencia desde</label>
            <lib-datepicker
            name="dateFromInsurancePerson"
            id="dateFromInsurancePerson"
            [useTime]="true"
            [defaultToday]="false"
            [disabledFutureDates]="true"
            formControlName="dateFromInsurance"
            (click)="_errorMessage = ''"
            [placeholder] ="'Fecha vigencia desde'"
            (ngModelChange)="onDateChange('dateFromInsurancePerson')"
            [maxDate]="today"
            [required]="false"
            ></lib-datepicker>
        </div>
        <div class="form-group col-6">
            <label for="dateToInsurancePerson" class="text-truncate mb-0" style="max-width: 100%;">Fecha de vigencia hasta</label>
            <lib-datepicker
            name="dateToInsurancePerson"
            id="dateToInsurancePerson"
            [defaultToday]="false"
            [disabledFutureDates]="false"
            [useTime]="true"
            formControlName="dateToInsurance"
            [placeholder] ="'Fecha vigencia hasta'"
            (click)="_errorMessage = ''"
            (ngModelChange)="onDateChange('dateToInsurancePerson')"
            [minDate]="minDateInsurance"
            [required]="false"
            ></lib-datepicker>
        </div>
        <div class="form-group col-4" >
            <custom-select
                [filterEnabled]="true"
                [labelText]="'Vehículo asociado'"
                [bordered]="true"
                name="vehiclePerson"
                id="vehiclePerson"
                (click)="_errorMessage = ''"
                formControlName="vehiclePerson"
                [(sourceList)]="vehiclePersonList"
                >
            </custom-select>
            </div>
        <div class="form-group col-4" [ngClass]="{'d-flex': personType?.value?.label === 'Otro' || personType?.value?.label === 'Other'}" >
        <!-- <div class="" [ngClass]="{'col-6 pl-0 pr-1': personType?.value?.value === 1, 'col-12 px-0': personType?.value?.value !== 1 }"> -->
            <custom-select
            [filterEnabled]="true"
            [labelText]="'Tipo de persona'"
            [bordered]="true"
            name="personType"
            id="personType"
            (click)="_errorMessage = ''"
            formControlName="personType"
            [(sourceList)]="_personTypeList"
            [required]="documentNumber.value"
            required>
            </custom-select>
        <!-- </div> -->
        </div>
        <!-- <div class="form-group col-12" *ngIf="personType?.value?.label === 'Otro' || personType?.value?.label === 'Other'">
            <label for="personDescription">Descripción</label>
            <input
            type="text"
            class="form-control"
            formControlName="personDescription"
            id="personDescription"
            name="personDescription"
            required/>
        </div> -->
        <div class="form-group col-4" >
          <custom-select
            [filterEnabled]="true"
            [labelText]="'Servicio'"
            [bordered]="true"
            name="assistanceType"
            id="assistanceType"
            formControlName="assistanceType"
            [(sourceList)]="_assistanceTypeList"
            required>
          </custom-select>
        </div>
        <div class="form-group col-4" >
          <custom-select
            [filterEnabled]="true"
            [labelText]="'Condición'"
            [bordered]="true"
            name="healthCondition"
            id="healthCondition"
            (click)="_errorMessage = ''"
            formControlName="healthCondition"
            [(sourceList)]="_healthConditionList"
            required>
          </custom-select>
        </div>
        <div class="form-group col-4 d-flex align-items-center">
            <div class="custom-control custom-checkbox mt-2">
              <input
                formControlName="transfer"
                (click)="_errorMessage = ''"
                type="checkbox"
                [name]="editing ? 'transfer'+'-editing' : 'transfer'"
                [id]="editing ? 'transfer' +'-editing' : 'transfer'"
                class="custom-control-input"/>
              <label class="custom-control-label" [for]="editing ? 'transfer' +'-editing' : 'transfer'">Traslado</label>
            </div>
        </div>
        <div class="form-group col-4">
            <custom-select
            [filterEnabled]="true"
            [labelText]="'Trasladado por'"
            [bordered]="true"
            [isDisabled]="!transfer.value"
            (click)="_errorMessage = ''"
            name="transferResponsible"
            id="transferResponsible"
            formControlName="transferResponsible"
            [(sourceList)]="_transferResponsibleList"
            [required]="transfer.value ? true : false"
            ></custom-select>
        </div>
        <div class="form-group col-4">
            <custom-select
            [filterEnabled]="true"
            [labelText]="'Hospital'"
            [bordered]="true"
            [isDisabled]="!transfer.value"
            name="hospital"
            id="hospital"
            [useParentWidth]="true"
            formControlName="hospital"
            [(sourceList)]="_hospitalList">
            </custom-select>
        </div>
        <div class="form-group col-4">
            <label for="destination">Destino</label>
            <input
                type="text" 
                maxlength="255"
                name="destination"
                formControlName="destination"
                (click)="_errorMessage = ''"
                class="form-control" 
                id="destination" 
                [placeholder]="'Destino traslado'">
        </div>
        <div class="form-group col-4" >
          <label for="responsible" class="text-truncate mb-0" style="max-width: 100%;">Responsable por daños</label>
          <custom-select
            [filterEnabled]="true"
            [bordered]="true"
            name="responsible"
            id="responsible"
            (click)="_errorMessage = ''"
            formControlName="responsible"
            [(sourceList)]="_responsibleList">
          </custom-select>
        </div>
        <div class="form-group col-12">
            <label for="notes">Notas y observaciones</label>
            <textarea
                type="text" 
                customFocus 
                maxlength="500"
                name="notes"
                formControlName="notes"
                (click)="_errorMessage = ''"
                rows="2"
                class="form-control" 
                id="notes" 
                [placeholder]="'Notas y observaciones'"
            ></textarea>
        </div>
    </div>
    <div class="alert alert-danger col-sm-12" *ngIf="_errorMessage">{{_errorMessage}}</div>
</div>